import React from 'react';
import PropTypes from 'prop-types';
import UserSearch from 'components/UserSearch';
import assigneeStyles from './assigneeSelect.scss';

const AssigneeSelect = (props) => {
  const { className, onChange, placeholder, installerOnly } = props;
  const employableTypes = installerOnly ? ['Installer'] : ['Installer', 'Employee'];
  return (<span>
    <label
      htmlFor="select"
      className={assigneeStyles.label}
    >{installerOnly ? 'Installer' : 'Assignee'}</label>
    <UserSearch
      isAssigneeSelect
      employableType={employableTypes}
      initialValues={{}}
      onChange={onChange}
      className={className}
      placeholder={placeholder}
    />
  </span>);
};

AssigneeSelect.defaultProps = {
  installerOnly: false,
  onChange: () => {},
  className: '',
  placeholder: 'Select Assignee',
};

AssigneeSelect.propTypes = {
  installerOnly: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  placeholder: PropTypes.string,
};

export default AssigneeSelect;



// WEBPACK FOOTER //
// ./client/app/shared/components/formElements/AssigneeSelect/index.jsx